import React from "react";

function SecondaryTitle({ title }) {
  return (
    <div>
      <p className="text-bluish font font-Playfair font-semibold text-2xl">
        {title}
      </p>
    </div>
  );
}

export default SecondaryTitle;
